/* Selection du tiroir panier (anciennement « Completez votre tenue »).
   Voir snippets/ivelano-panier.liquid.

   v37 (03/11/2026) : la selection ne propose plus les accessoires mais la
   collection de l'accueil « Accueil · Toutes les pieces »
   (/collections/accueil-toutes-les-pieces : 4 meilleures ventes puis
   pieces entre 110 et 145 EUR, ordre manuel). Elle rappelle l'offre
   automatique « 2e parka : -20 % » (1 article achete = -20 % sur le 2e,
   une fois par commande, non cumulable, accessoires exclus) :
   - 1 piece eligible au panier : « Votre 2e parka a -20 % » ;
   - 0 piece eligible (accessoires seuls) : rappel de l'offre ;
   - 2 pieces eligibles ou plus : l'offre est deja appliquee, le titre ne
     promet plus de remise.
   Toutes les pieces de la collection sont eligibles a l'offre (verifie le
   03/11/2026 contre la collection « Eligibles offre quantite »).

   v21 (21/10/2026) :
   - ORDINATEUR (plus de 1024 px) : panneau a GAUCHE de l'ecran, ouvert en
     meme temps que le tiroir panier (qui reste a droite). Grille de 2
     colonnes, pastilles de couleur, menu de taille, bouton « Ajouter ».
     La croix ferme le panneau sans fermer le panier (jusqu'au prochain
     rechargement de page). Le panneau vit DANS #iv-cart : il herite des
     styles, se ferme avec le panier et le voile reste cliquable.
   - MOBILE (1024 px et moins) : carrousel sous les articles du tiroir.

   Regles communes :
   - Seulement les declinaisons disponibles ; jamais un produit deja dans
     le panier.
   - Rien si le panier est vide.
   - Ajout sans quitter le panier, puis window.ivCartRefresh (expose par
     assets/ivelano-panier.js), qui rappelle html() : le panneau se met a
     jour tout seul.
   - Echec de chargement : liste vide, pas de nouvel essai. */
(function(){
  if(window.ivReco) return;

  var SOURCE = '/collections/accueil-toutes-les-pieces/products.json?limit=50';
  var TYPES_ACC = ['gants', 'cache-cou', 'echarpe', 'echarpes', 'écharpe', 'écharpes', 'bonnet', 'bonnets'];
  var MAX_RAIL = 12;
  var BUREAU = window.matchMedia('(min-width:1025px)');
  var produits = null, chargement = null;
  var panneauFerme = false, dernierPanier = null, panneau = null;

  var nf = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function eur(prix){ return nf.format(parseFloat(prix) || 0) + '€'; }
  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function img(src, w){
    if(!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function estCouleur(nom){
    var n = String(nom || '').toLowerCase();
    return n.indexOf('couleur') > -1 || n.indexOf('coloris') > -1 || n.indexOf('color') > -1;
  }
  function teinte(val){
    var k = String(val || '').toLowerCase().replace(/\s+/g, '');
    var t = [
      ['noir','#14181A'],['blanc','#F1EDE6'],['ecru','#F1EDE6'],['écru','#F1EDE6'],['creme','#F1EDE6'],['crème','#F1EDE6'],
      ['rouge','#8E2A22'],['marine','#1F2A44'],['bleu','#3A5A80'],['kaki','#5A5C3D'],['vert','#2E3B33'],
      ['beige','#C8B79E'],['camel','#B58A5A'],['sable','#C8B79E'],['ivoire','#EEE6D3'],['saumon','#E0A090'],['rouille','#9A4A2A'],['fuchsia','#B0306A'],
      ['grisclair','#B9B7B2'],['grisfoncé','#4A4D51'],['gris','#6E7175'],['anthracite','#4A4D51'],
      ['rose','#D8AFAF'],['marron','#5B4636'],['brun','#5B4636'],['chocolat','#5B4636'],['violet','#8E7FA8'],['lilas','#8E7FA8'],
      ['jaune','#C9A227'],['moutarde','#C9A227'],['orange','#C4703A'],['café','#5B4636'],['cafe','#5B4636'],['camouflage','#5A5C3D']
    ];
    for(var i = 0; i < t.length; i++){ if(k.indexOf(t[i][0]) === 0) return t[i][1]; }
    for(var j = 0; j < t.length; j++){ if(k.indexOf(t[j][0]) > -1) return t[j][1]; }
    return '#C8C4BC';
  }

  function charger(){
    if(produits) return Promise.resolve(produits);
    if(chargement) return chargement;
    chargement = fetch(SOURCE, { headers: { 'Accept':'application/json' } })
      .then(function(r){ return r.ok ? r.json() : { products: [] }; })
      .then(function(j){
        produits = (j.products || []).map(function(p){
          var imgs = {};
          (p.images || []).forEach(function(i){ imgs[i.id] = i.src; });
          var vars = (p.variants || []).map(function(v){
            return {
              id: v.id, titre: v.title, prix: v.price, barre: v.compare_at_price,
              dispo: !!v.available, o: [v.option1, v.option2, v.option3],
              image: (v.featured_image && v.featured_image.src) || imgs[v.image_id] || ''
            };
          });
          return {
            id: p.id, handle: p.handle,
            nom: String(p.title || '').split(' | ')[0],
            image: (p.images && p.images[0] && p.images[0].src) || '',
            options: (p.options || []).filter(function(o){
              return !(o.values && o.values.length === 1 && o.values[0] === 'Default Title');
            }),
            variantes: vars
          };
        }).filter(function(p){ return p.variantes.some(function(v){ return v.dispo; }); });
        return produits;
      })
      .catch(function(){ produits = []; return produits; });
    return chargement;
  }

  function estAccessoire(it){
    return TYPES_ACC.indexOf(String(it.product_type || '').toLowerCase().trim()) > -1;
  }

  /* Nombre de pieces eligibles a l'offre (tout sauf les accessoires). */
  function nbEligibles(panier){
    var n = 0;
    (panier.items || []).forEach(function(it){ if(!estAccessoire(it)) n += (it.quantity || 0); });
    return n;
  }

  /* Titre et sous-titre selon l'etat du panier. */
  function textes(panier){
    var n = nbEligibles(panier);
    if(n === 1) return {
      t: 'Votre 2ᵉ parka à −20 %',
      s: 'Ajoutez une deuxième pièce : la remise de −20 % s’applique automatiquement au panier.'
    };
    if(n === 0) return {
      t: '1 parka achetée = −20 % sur la deuxième',
      s: 'Remise appliquée automatiquement au panier dès deux pièces.'
    };
    return { t: 'Complétez votre vestiaire', s: '' };
  }

  /* Produits a proposer pour ce panier ([] si rien). */
  function aProposer(panier){
    if(!produits || !panier || !panier.item_count) return [];
    var dans = {};
    (panier.items || []).forEach(function(it){ dans[it.product_id] = 1; });
    return produits.filter(function(p){ return !dans[p.id]; });
  }

  function prixHtml(v){
    var b = parseFloat(v.barre), p = parseFloat(v.prix);
    return (b && b > p ? '<s>' + eur(v.barre) + '</s> ' : '') + eur(v.prix);
  }

  var STYLE_SOUS = 'margin:4px 0 0;font-size:12.5px;line-height:1.45;color:var(--brume,#8E8B85) !important;letter-spacing:0;text-transform:none';

  /* ---------------- MOBILE : carrousel ---------------- */
  function carteRail(p){
    var dispo = p.variantes.filter(function(v){ return v.dispo; });
    var v0 = dispo[0];
    var choix = '';
    if(p.options.length){
      choix = '<select class="iv-reco__s" data-iv-reco-v aria-label="Choisir la déclinaison de ' + esc(p.nom) + '">'
        + dispo.map(function(v){
            return '<option value="' + v.id + '" data-prix="' + esc(v.prix) + '">' + esc(v.titre) + '</option>';
          }).join('')
        + '</select>';
    }
    return '<div class="iv-reco__c" data-iv-reco-p="' + p.id + '">'
      + '<a class="iv-reco__img" href="/products/' + esc(p.handle) + '" tabindex="-1">'
        + (p.image ? '<img src="' + esc(img(p.image, 300)) + '" alt="' + esc(p.nom) + '" width="150" height="150" loading="lazy">' : '')
      + '</a>'
      + '<a class="iv-reco__n" href="/products/' + esc(p.handle) + '">' + esc(p.nom) + '</a>'
      + '<p class="iv-reco__p" data-iv-reco-prix>' + eur(v0.prix) + '</p>'
      + choix
      + '<button type="button" class="iv-reco__add" data-iv-reco-add data-vid="' + v0.id + '">Ajouter</button>'
    + '</div>';
  }

  /* ---------------- ORDINATEUR : panneau de gauche ---------------- */
  function creerPanneau(){
    if(panneau) return panneau;
    var tiroir = document.getElementById('iv-cart');
    if(!tiroir) return null;
    panneau = document.createElement('aside');
    panneau.className = 'iv-acc';
    panneau.setAttribute('aria-label', 'Sélection Ivelano');
    panneau.innerHTML = '<div class="iv-acc__top">'
        + '<div><p class="iv-acc__t" data-iv-acc-titre></p><p data-iv-acc-sous style="' + STYLE_SOUS + '"></p></div>'
        + '<button class="iv-acc__x" type="button" data-iv-acc-x aria-label="Fermer la sélection">'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke-linecap="round"/></svg>'
        + '</button>'
      + '</div>'
      + '<div class="iv-acc__body"><div class="iv-acc__grid" data-iv-acc-grid></div></div>';
    tiroir.appendChild(panneau);
    panneau.addEventListener('click', function(e){
      if(e.target.closest('[data-iv-acc-x]')){ panneauFerme = true; panneau.classList.remove('is-on'); }
    });
    return panneau;
  }

  function choixInitial(p){
    var v = p.variantes.filter(function(x){ return x.dispo; })[0];
    return v ? v.o.slice() : [];
  }
  function trouver(p, sel){
    return p.variantes.filter(function(v){
      for(var i = 0; i < p.options.length; i++){ if(v.o[i] !== sel[i]) return false; }
      return true;
    })[0] || null;
  }

  function carteAcc(p){
    var sel = choixInitial(p);
    var v = trouver(p, sel) || p.variantes[0];
    var opts = p.options.map(function(o, i){
      if(estCouleur(o.name)){
        return '<div class="iv-acc__o"><span class="iv-acc__on">' + esc(o.name) + ' <em data-iv-acc-val="' + i + '">' + esc(sel[i]) + '</em></span>'
          + '<div class="iv-acc__sw">' + o.values.map(function(val){
              var ok = p.variantes.some(function(x){ return x.dispo && x.o[i] === val; });
              return '<button type="button" data-iv-acc-opt="' + i + '" data-val="' + esc(val) + '"'
                + ' aria-pressed="' + (val === sel[i] ? 'true' : 'false') + '"' + (ok ? '' : ' disabled')
                + ' title="' + esc(val) + '" aria-label="' + esc(o.name) + ' ' + esc(val) + '">'
                + '<i style="background:' + teinte(val) + '"></i></button>';
            }).join('') + '</div></div>';
      }
      return '<div class="iv-acc__o"><select class="iv-acc__s" data-iv-acc-opt="' + i + '" aria-label="' + esc(o.name) + '">'
        + o.values.map(function(val){
            return '<option value="' + esc(val) + '"' + (val === sel[i] ? ' selected' : '') + '>' + esc(o.name) + ' : ' + esc(val) + '</option>';
          }).join('') + '</select></div>';
    }).join('');
    return '<div class="iv-acc__c" data-iv-acc-p="' + p.id + '" data-sel="' + esc(JSON.stringify(sel)) + '">'
      + '<a class="iv-acc__img" href="/products/' + esc(p.handle) + '" tabindex="-1">'
        + '<img data-iv-acc-img src="' + esc(img(v.image || p.image, 500)) + '" alt="' + esc(p.nom) + '" width="250" height="250" loading="lazy">'
      + '</a>'
      + '<a class="iv-acc__n" href="/products/' + esc(p.handle) + '">' + esc(p.nom) + '</a>'
      + '<p class="iv-acc__p" data-iv-acc-prix>' + prixHtml(v) + '</p>'
      + opts
      + '<button type="button" class="iv-acc__add" data-iv-acc-add data-vid="' + v.id + '"' + (v.dispo ? '' : ' disabled') + '>'
        + (v.dispo ? 'Ajouter' : 'Épuisé') + '</button>'
    + '</div>';
  }

  function majCarte(c){
    var p = (produits || []).filter(function(x){ return String(x.id) === c.getAttribute('data-iv-acc-p'); })[0];
    if(!p) return;
    var sel = JSON.parse(c.getAttribute('data-sel') || '[]');
    var v = trouver(p, sel);
    var b = c.querySelector('[data-iv-acc-add]');
    var pr = c.querySelector('[data-iv-acc-prix]');
    var im = c.querySelector('[data-iv-acc-img]');
    c.querySelectorAll('[data-iv-acc-opt]').forEach(function(el){
      var i = +el.getAttribute('data-iv-acc-opt');
      if(el.tagName === 'BUTTON') el.setAttribute('aria-pressed', el.getAttribute('data-val') === sel[i] ? 'true' : 'false');
    });
    c.querySelectorAll('[data-iv-acc-val]').forEach(function(el){ el.textContent = sel[+el.getAttribute('data-iv-acc-val')] || ''; });
    if(!v){ b.disabled = true; b.textContent = 'Indisponible'; return; }
    b.dataset.vid = v.id;
    b.disabled = !v.dispo;
    b.textContent = v.dispo ? 'Ajouter' : 'Épuisé';
    pr.innerHTML = prixHtml(v);
    if(v.image && im) im.src = img(v.image, 500);
  }

  function majPanneau(panier){
    if(!BUREAU.matches){ if(panneau) panneau.classList.remove('is-on'); return; }
    var liste = aProposer(panier);
    var pa = creerPanneau();
    if(!pa) return;
    if(!liste.length || panneauFerme){ pa.classList.remove('is-on'); return; }
    var tx = textes(panier);
    pa.querySelector('[data-iv-acc-titre]').textContent = tx.t;
    var so = pa.querySelector('[data-iv-acc-sous]');
    so.textContent = tx.s;
    so.style.display = tx.s ? '' : 'none';
    pa.setAttribute('aria-label', tx.t);
    pa.querySelector('[data-iv-acc-grid]').innerHTML = liste.map(carteAcc).join('');
    pa.classList.add('is-on');
  }

  /* Appele par le tiroir a chaque redessin. Sur ordinateur : met a jour
     le panneau de gauche et ne met rien dans le tiroir. Sur mobile :
     renvoie le carrousel. */
  function html(panier){
    dernierPanier = panier;
    majPanneau(panier);
    if(BUREAU.matches) return '';
    var liste = aProposer(panier).slice(0, MAX_RAIL);
    if(!liste.length) return '';
    var tx = textes(panier);
    return '<div class="iv-reco" role="region" aria-label="' + esc(tx.t) + '">'
      + '<p class="iv-reco__t">' + esc(tx.t) + '</p>'
      + (tx.s ? '<p style="' + STYLE_SOUS + ';margin:-6px 0 12px">' + esc(tx.s) + '</p>' : '')
      + '<div class="iv-reco__rail">' + liste.map(carteRail).join('') + '</div>'
    + '</div>';
  }

  /* Passage ordinateur <-> mobile : on redessine le tiroir. */
  var basculer = function(){ if(dernierPanier && window.ivCartRefresh) window.ivCartRefresh(); };
  if(BUREAU.addEventListener) BUREAU.addEventListener('change', basculer);
  else if(BUREAU.addListener) BUREAU.addListener(basculer);

  /* ---------------- Evenements ---------------- */
  document.addEventListener('change', function(e){
    var s = e.target.closest && e.target.closest('[data-iv-reco-v]');
    if(s){
      var c = s.closest('.iv-reco__c');
      var o = s.options[s.selectedIndex];
      var b = c.querySelector('[data-iv-reco-add]');
      var pr = c.querySelector('[data-iv-reco-prix]');
      if(b) b.dataset.vid = s.value;
      if(pr && o) pr.textContent = eur(o.getAttribute('data-prix'));
      return;
    }
    var a = e.target.closest && e.target.closest('select[data-iv-acc-opt]');
    if(a){
      var ca = a.closest('.iv-acc__c');
      var sel = JSON.parse(ca.getAttribute('data-sel') || '[]');
      sel[+a.getAttribute('data-iv-acc-opt')] = a.value;
      ca.setAttribute('data-sel', JSON.stringify(sel));
      majCarte(ca);
    }
  });

  function ajouter(b, vid){
    b.disabled = true; b.textContent = 'Ajout…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    }).then(function(r){
      if(!r.ok) throw new Error('ajout');
      return window.ivCartRefresh ? window.ivCartRefresh() : null;
    }).catch(function(){
      b.disabled = false; b.textContent = 'Indisponible';
    });
  }

  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    var sw = e.target.closest('button[data-iv-acc-opt]');
    if(sw && !sw.disabled){
      var c = sw.closest('.iv-acc__c');
      var sel = JSON.parse(c.getAttribute('data-sel') || '[]');
      sel[+sw.getAttribute('data-iv-acc-opt')] = sw.getAttribute('data-val');
      c.setAttribute('data-sel', JSON.stringify(sel));
      majCarte(c);
      return;
    }
    var ba = e.target.closest('[data-iv-acc-add]');
    if(ba && !ba.disabled){ e.preventDefault(); ajouter(ba, parseInt(ba.dataset.vid, 10)); return; }
    var b = e.target.closest('[data-iv-reco-add]');
    if(b && !b.disabled){
      e.preventDefault();
      var cr = b.closest('.iv-reco__c');
      var s = cr && cr.querySelector('[data-iv-reco-v]');
      var vid = parseInt((s && s.value) || b.dataset.vid, 10);
      if(vid) ajouter(b, vid);
    }
  });

  window.ivReco = { charger: charger, pret: function(){ return produits !== null; }, html: html };
})();
